/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LightbulbIcon24Regular = forwardRef('LightbulbIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.086 9.416a5.914 5.914 0 1 1 9.658 4.579c-.49.4-.913.942-1.121 1.59a.75.75 0 1 0 1.429.457c.1-.316.326-.628.642-.887a7.414 7.414 0 1 0-9.389 0c.317.259.542.571.644.887a.75.75 0 1 0 1.428-.457c-.208-.648-.632-1.19-1.121-1.59a5.901 5.901 0 0 1-2.17-4.579Z" }),
        React.createElement("path", { d: "M8.761 19.05h6.49a.75.75 0 0 0 0-1.5h-6.49a.75.75 0 0 0 0 1.5Z" }),
        React.createElement("path", { d: "M9.564 21.25a.75.75 0 0 1 .75-.75h3.372a.75.75 0 0 1 0 1.5h-3.372a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M12.75 9.816a.75.75 0 0 0-1.5 0v5.903a.75.75 0 0 0 1.5 0V9.816Z" })));
});
